import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';

// import { PrefetchMethod } from '@/config';

import {
    SET_FETCH_MARKET_REPORT_STATUS,
    GET_MARKET_REPORT,
    FETCH_MARKET_REPORT_DATA
} from '../../_store/constants';
import { marketReportStatus } from '../../_config';
// import { fetchMarketReportData } from '../../asyncData';
// import { mapAsyncData } from '../../../../plugins/asyncData'
import hasLocationMixin from '../../_mixins/has-location/index';
import { numberFormat, currencyFormat } from '@/common/format';
export default {
    i18next: {
        ns: 'md-snapshot-search'
    },
    mixins: [hasLocationMixin],
    // async [PrefetchMethod](){
    //     await this.asyncDataPromise;
    //     if (this.type !== 'insight'){
    //         await mapAsyncData(fetchMarketReportData).call(this);
    //     }
        
    // },
    props: {
        title: {
            default: ''
        },
        type: {
            default: ''
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency?.symbol,
            "siteId": "siteId"
        }),
        ...mapState({
            "marketReport": store => store.marketReport || {},
            "searchParams": store => store.searchParams,
            "showMarketComing": "showMarketComing"
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        timeRange() {
            const now = new Date();
            const prev = new Date(Date.now() - 1000 * 60 * 60 * 24 * 30);
            return `(${this.$ft.formatDate(
                prev,
                'MMM dd, yyyy'
            )} - ${this.$ft.formatDate(now, 'MMM dd, yyyy')})`;
        },
        //  from marketReport get in soldListing data for display 
        soldListing() {
            let res = {
                title: this.$t('md-snapshot-search.soldListings'),
                data: this.showMarketComing
                    ? '?'
                    : numberFormat(this.marketReport?.count),
                status: this.calcChangeStatus(this.marketReport?.countChangeVal), // -1  reduce ，0  constant  1  increase 
                changeNum: numberFormat(
                    Math.abs(this.marketReport.countChangeVal)
                ), //  changing value 
                dataComing: this.showMarketComing //  first data acquisition 
            };
            return res;
        },
        //  from marketReport get in avgSalePrice data for display 
        avgSalePrice() {
            return {
                title: this.$t('md-snapshot-search.averageSalesPrice'),
                data: this.showMarketComing
                    ? '?'
                    : this.marketReport.avgSoldPrice >= Math.pow(10, 6)
                        ? currencyFormat(this.marketReport.avgSoldPrice, true, 2, this.currencySymbol)
                        : currencyFormat(this.marketReport.avgSoldPrice, true, 0, this.currencySymbol),
                status: this.calcChangeStatus(
                    this.marketReport.avgSoldPriceChangeVal
                ), // -1  reduce ，0  constant  1  increase 
                changeNum:
                    Math.abs(this.marketReport.avgSoldPriceChangeVal) >=
                        Math.pow(10, 6)
                        ? numberFormat(
                            Math.abs(this.marketReport.avgSoldPriceChangeVal),
                            true,
                            2
                        )
                        : numberFormat(
                            Math.abs(this.marketReport.avgSoldPriceChangeVal),
                            true
                        ), //  changing value 
                dataComing: this.showMarketComing //  first data acquisition 
            };
        },
        //  from marketReport get in avgDaysOnMarket data for display 
        avgDaysOnMarket() {
            if (this.marketReport.avgOnSaleDays !== 0) {
                return {
                    title: this.$t('md-snapshot-search.averageDaysOnMarket'),
                    data: this.showMarketComing
                        ? '?'
                        : numberFormat(this.marketReport.avgOnSaleDays),
                    status: this.calcChangeStatus(
                        this.marketReport.avgOnSaleDaysChangeVal
                    ), // -1  reduce ，0  constant  1  increase 
                    changeNum: numberFormat(
                        Math.abs(this.marketReport.avgOnSaleDaysChangeVal)
                    ), //  changing value 
                    dataComing: this.showMarketComing, //  first data acquisition 
                    class: 'diff-color'
                };
            } else {
                return {
                    title: this.$t('md-snapshot-search.medianSalesPrice'),
                    data: this.showMarketComing
                        ? '?'
                        : currencyFormat(
                            this.marketReport.medianSoldPrice,
                            true,
                            0,
                            this.currencySymbol
                        ),
                    status: this.calcChangeStatus(
                        this.marketReport.medianSoldPriceChangeVal
                    ), // -1  reduce ，0  constant  1  increase 
                    changeNum: numberFormat(
                        Math.abs(this.marketReport.medianSoldPriceChangeVal),
                        true
                    ), //  changing value 
                    dataComing: this.showMarketComing //  first data acquisition 
                };
            }
        }
    },
    watch: {
        searchParams: {
            deep: true,
            handler() {
                if (this.type !== 'insight') {
                    this.fetchMarketReportData();
                }
            }
        }
    },
    mounted() {
        if (this.asyncDataPromise) {
            this.asyncDataPromise.then(() => {
                if (this.type !== 'insight') {
                    this.fetchMarketReportData();
                }
            });
        } else {
            if (this.type !== 'insight') {
                this.fetchMarketReportData();
            }
        }
    },
    methods: {
        ...mapActions({
            "getMarketReport": GET_MARKET_REPORT,
            "setFetchStatus": SET_FETCH_MARKET_REPORT_STATUS,
            "fetchMarketReportData": FETCH_MARKET_REPORT_DATA
        }),
        calcChangeStatus(val) {
            //  past 30 day or past 30-60 days did not sell the house
            if (
                !this.marketReport?.count ||
                !this.marketReport?.hasSoldListingInLastMonth
            ) {
                return 3;
            }
            //  when the past 30-60 Days when no listings were sold ， All lift values are  -
            if (!this.marketReport?.hasSoldListingInLastMonth) {
                return 2;
            }

            if (val > 0) {
                return 1;
            } else if (val < 0) {
                return -1;
            } else {
                return 0;
            }
        },
        async getInsightMarketData(params) {
            params = { ...params, siteId: this.siteId };
            await this.getMarketReport({ data: params });
            await this.setFetchStatus(marketReportStatus.loaded);
        }
    },
    // beforeCreate() {
    //     if (this.type !== 'insight') {
    //         this.$watch(
    //             'searchParams',
    //             () => {
    //                 this.fetchMarketReportData();
    //             },
    //             {
    //                 // immediate: true,
    //                 deep: true
    //             }
    //         );
    //     }
    // }
};
